export default function PageHeader({ overline, title, description, actions, testId }) {
  return (
    <div className="border-b border-neutral-200 bg-white" data-testid={testId}>
      <div className="px-10 py-8 flex items-end justify-between gap-6">
        <div>
          {overline && <div className="overline mb-3">{overline}</div>}
          <h1 className="font-display text-5xl tracking-tighter leading-none">{title}</h1>
          {description && (
            <p className="text-sm text-neutral-500 mt-3 max-w-xl">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
